import {BrowserModule} from '@angular/platform-browser';
import {Component, NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {HttpModule} from '@angular/http';

import {AppComponent} from './app.component';
import {HomeComponent} from './pages/home/home.component';
import {ServicesComponent} from './pages/services/services.component';
import {AppRoutingModule} from './app-routing.module';
import {WorkComponent} from './pages/work-list/work-list.component';
import {WorkDetailComponent} from './pages/work-detail/work-detail.component';
import {WorksService} from './services/works.service';
import {ScrollPositionService} from './services/scroll-position.service';
import {TeamComponent} from './pages/team/team.component';
import {ContactComponent} from './pages/contact/contact.component';
import {FinalActionComponent} from './parts/final-action/final-action.component';
import {FormsModule} from '@angular/forms';
import {CallbackService} from './services/callback.service';
import {KenticoService} from './services/kentico.service';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    ServicesComponent,
    WorkComponent,
    WorkDetailComponent,
    TeamComponent,
    ContactComponent,
    FinalActionComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'gridhaus-app'}),
    HttpModule,
    AppRoutingModule,
    FormsModule
  ],
  providers: [WorksService, ScrollPositionService, CallbackService, KenticoService],
  bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/app.module.ts